export default __webpack_public_path__ + "static/media/cp.64abe525.svg";